<mat-dialog-content class="container__preview-image">
  <div class="container__preview-image-content">
    <button class="close-button" mat-icon-button mat-dialog-close aria-label="Close">
      <mat-icon fontSet="material-icons-outlined">close</mat-icon>
    </button>
    <img [src]="this.data.image" [width]="data.width" [height]="data.height" alt="image">
  </div>
</mat-dialog-content>